<template>
  <div class="card">
    <div class="card-header border-0 bg-success p-2">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">NOC</h3>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table">
        <thead>
          <th>Đơn Vị</th>
          <th>Họ Tên</th>
          <th>T.CN</th>
          <th>T.Từ</th>
          <th>Vào</th>
          <th>Ghi chú</th>
          <th></th>
        </thead>
        
          <tbody>
            <tr v-for="(job, inx) in jobs" :key="inx">
              <th class="py-1">
                {{ job.orgName}}
              </th>     
              <td  class="py-1">
                {{job.tenant}}
              </td>
              <td class="py-1" width="5%">
                {{job.l2Id}}
              </td>
              <td  class="py-1" width="5%">
                {{job.l3Id}}
              </td>
              <td  class="py-1">
                {{formattime(job.in3Date)}}
              </td>
              <td class="py-1">
                {{job.notes}}
              </td>  
              <td class="text-right py-1" >
                <base-button type="warning" class="btn-sm" @click="setNote(job)">Note</base-button>
                <base-button type="primary" class="btn-sm" v-if="permitl3" @click="precheck(job)">Ra</base-button>
              </td>
              
            </tr>
        </tbody>
        
      </table>
    </div>
    <modal :show.sync="modals.modal0">
      <template slot="header">
      <h5 class="modal-title" id="exampleModalLabel">Ghi Chú</h5>
      </template>
      <div>
        <base-input class="mb-4">
            <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="ghi chú thêm ..." v-model="currentjob.notes"></textarea>
          </base-input>
      </div>
      <template slot="footer">
        <base-button type="secondary" @click="modals.modal0 = false">Hủy</base-button>
        <base-button type="primary" @click="updateNote" >Lưu</base-button>
      </template>
    </modal>
    <modal :show.sync="modals.modal1">
      <template slot="header">
      <h5 class="modal-title" id="exampleModalLabel">Ghi chú</h5>
      </template>
      <div>
      <h3>Khách hàng đã hoàn trả dụng cụ ?</h3>
      </div>
      <template slot="footer">
        <base-button type="secondary" class="btn-sm" @click="modals.modal1 = false">Chưa hoàn trả</base-button>
        <base-button type="primary" class="btn-sm" @click="checkoutlayer3(currentjob)" >Đã hoàn trả</base-button>
      </template>
    </modal>
  </div>
</template>
<script>
  export default {
    name: 'layer_3',
    props: {
        jobs: {
        type: Array
      },
    },
    data() {
      return {
        modals: {
          modal0: false,
          modal1: false
        },
        currentjob: ''
        }
    },
    methods: {
      checkoutlayer3(job) {
        let data = {
          jobId: job._id,
          location: job.location
        }
        if(job.location =='TTN') {
          job.status = 7
          job.out3Date = this.$moment()
        }
        else if (job.location =='NTMK') {
          job.status = 9
          job.out1Date = this.$moment()
          job.out3Date = this.$moment()
          job.openning = false
        } else if (job.location =='DBP') {
          job.status = 9
          job.out1Date = this.$moment()
          job.out3Date = this.$moment()
          job.openning = false
        }
        if(job.l3Id) {
          let card = { layer: 2, id:job.l3Id }
          this.$emit('addThe',card)
        }
        this.$store.dispatch('updatejob', job)
        this.$http.post('/jobs/out/layer3', data)     
        this.modals.modal1 = false
      },
      formattime(curdate) {
        if(curdate){
          return this.$moment.tz(curdate,"Asia/Ho_Chi_Minh").format("DD/MM/YYYY HH:mm")
        }
        return ''
      },
      setNote(job) {
        this.modals.modal0 = true
        this.currentjob = job
      },
      updateNote(){
        this.$store.dispatch('updatejob', this.currentjob)
        this.$http.post('jobs/edit', this.currentjob)
        this.currentjob = ''
        this.modals.modal0 = false
      },
      precheck(job){
        if(job.notes){
          this.currentjob = job
          this.modals.modal1 = true
          
        }
        else{
          this.checkoutlayer3(job)
        }
      }
    },
 
   computed: {
      permitl1() {
          return this.$store.getters.permit_l1
        },
        permitl2() {
          return this.$store.getters.permit_l2
        },
        permitl3() {
          return this.$store.getters.permit_l3
        }
   },
  }
</script>
<style>
</style>
